<header class="section-inset-y scroll-trigger header-play" id="header">
  <div class="header-play__gradient"></div>
  <div class="pt-topbar container text-center header-play__inner">
    <h2 class="fs-display-0 fst-italic header-play__title splitting splitting--letter-in" *ngIf="title || header?.title" splitting>
      <span>{{ title || header?.title }}</span>

      <app-text-shape class="header-play__title__shape" [shape]="'squiggle-07'" [autoplay]="true" [shapeColor]="'primary'"></app-text-shape>
    </h2>

    <p [ngClass]="header?.introTextBig ? 'h3' : 'fs-body-lg'" [innerHTML]="header?.text" class="anim-fade-up delay--1 fw-bold mt-5">
      {{ header?.text }}
    </p>

    <span class="simple-scroll-indicator anim-fade-up delay--3 mt-5"><span class="sr-only">Scroll omlaag om meer te leren</span></span>

    <!--<fstr-link
      class="d-block anim-fade-up delay--2"
      *ngIf="header?.button?.url || header?.button?.routerLink"
      [button]="header?.button!"
      [cssClasses]="'mt-md-3 button button--primary-gradient has--dot'"
    ></fstr-link>-->
  </div>
</header>
